module.exports = __webpack_public_path__ + "static/media/samSmileyResume.759a24e1.pdf";